import { useRef, useState, useEffect } from "react";
import BiodataForm from "./BiodataForm";
import TemplateSelector from "./TemplateSelector";
import BiodataContainer from "./BiodataContainer";
import { defaultSections } from "../../data";
 console.log("defaultSections",defaultSections);
const STORAGE_KEY = "biodata_sections";
const TEMPLATE_STORAGE_KEY = "biodata_template";

const toBase64 = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = url;

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      canvas.getContext("2d").drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };

    img.onerror = () =>
      reject("Template image cannot be loaded due to CORS");
  });


function Biodatamain() {
 const idRef = useRef(1);
const getId = () => idRef.current++;

  // ===============================
  // SECTIONS STATE (unchanged)
  // ===============================
  const [sections, setSections] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch {}
    }

    return defaultSections.map((s) => ({
      ...s,
      id: getId(),
      fields: s.fields.map((f) => ({ ...f, id: getId() })),
    }));
  });

  // ===============================
  // TEMPLATE STATE (IMPORTANT)
  // ===============================
  const [template, setTemplate] = useState(() => {
    const saved = localStorage.getItem(TEMPLATE_STORAGE_KEY);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch {}
    }
    return null;
  });

  // ===============================
  // AUTO SAVE SECTIONS
  // ===============================
  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(sections));
  }, [sections]);

  // ===============================
  // TEMPLATE SELECT HANDLER (CORS FIX)
  // ===============================
 const handleSelectTemplate = async (t) => {
  try {
    // 🔥 ALWAYS convert
    const base64 = t.img.startsWith("data:")
      ? t.img
      : await toBase64(t.img);

    const finalTemplate = { ...t, img: base64 };

    setTemplate(finalTemplate);
    localStorage.setItem(
      "biodata_template",
      JSON.stringify(finalTemplate)
    );
  } catch (err) {
    alert(
      "This template cannot be downloaded due to image restrictions."
    );
    console.error(err);
  }
};
const [userImage, setUserImage] = useState(null);

// ⬇️ load once on app start
useEffect(() => {
  const savedImage = localStorage.getItem("bdm_user_image");
  if (savedImage) {
    setUserImage(savedImage);
  }
}, []);

const resetAllData = () => {
  // 🔥 Clear localStorage
  localStorage.removeItem("biodata_sections");
  localStorage.removeItem("biodata_template");
  localStorage.removeItem("bdm_user_image");

  // 🔥 Reset sections with fresh IDs
  idRef.current = 1;
  setSections(
    defaultSections.map((s) => ({
      ...s,
      id: idRef.current++,
      fields: s.fields.map((f) => ({
        ...f,
        id: idRef.current++,
      })),
    }))
  );

  // 🔥 Reset image
  setUserImage(null);

  // 🔥 Reset template
  setTemplate(null);
};
  return (
    <>
    <div className="row ">
        <div className="col-md-6">
            <BiodataForm sections={sections} setSections={setSections}  userImage={userImage}
        setUserImage={setUserImage}  onReset={resetAllData}  />
        </div>
        <div className="col-md-6">
            {template ? (
              <BiodataContainer sections={sections} template={template} userImage={userImage}/>
            ) : (
              <div>Please select a template</div>
            )}
        </div>
    </div>
            <TemplateSelector selected={template} onSelect={handleSelectTemplate} />
   </>
  );
}

export default Biodatamain;
